import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const ImageUpload = ({ siteId, tenantId, onImagesUploaded, existingImages = [] }) => {
  const [uploading, setUploading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
  };

  const handleUpload = async () => {
    if (!selectedFiles.length) return;

    setUploading(true);
    const formData = new FormData();
    selectedFiles.forEach(file => {
      formData.append('images', file);
    });

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_BASE_URL}/api/sites/${siteId}/images`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenantId,
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      setSelectedFiles([]);
      document.getElementById('imageInput').value = '';
      onImagesUploaded(response.data.images);
    } catch (error) {
      console.error('Upload failed:', error);
      alert('Upload failed: ' + (error.response?.data?.message || error.message));
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteImage = async (imageId) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(
        `${API_BASE_URL}/api/sites/${siteId}/images/${imageId}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'x-tenant-id': tenantId
          }
        }
      );
      onImagesUploaded();
    } catch (error) {
      console.error('Delete failed:', error);
      alert('Delete failed: ' + (error.response?.data?.message || error.message));
    }
  };

  return (
    <div className="image-upload-section">
      <h4>Site Images</h4>
      
      <div className="upload-controls">
        <input
          id="imageInput"
          type="file"
          multiple
          accept="image/*"
          onChange={handleFileSelect}
          className="form-control mb-2"
        />
        <button
          onClick={handleUpload}
          disabled={!selectedFiles.length || uploading}
          className="btn btn-primary"
        >
          {uploading ? 'Uploading...' : `Upload ${selectedFiles.length} Image(s)`}
        </button>
      </div>

      {existingImages.length > 0 && (
        <div className="existing-images mt-3">
          <h5>Current Images</h5>
          <div className="row">
            {existingImages.map((image, index) => (
              <div key={image._id || index} className="col-md-3 mb-3">
                <div className="card">
                  <img
                    src={`${API_BASE_URL}${image.path}`}
                    alt={image.originalName}
                    className="card-img-top"
                    style={{ height: '150px', objectFit: 'cover' }}
                  />
                  <div className="card-body p-2">
                    <small className="text-muted">{image.originalName}</small>
                    <button
                      onClick={() => handleDeleteImage(image._id)}
                      className="btn btn-sm btn-danger mt-1 w-100"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageUpload;